import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Vendors } from './components/Vendors';
import { MediaFeature } from './components/MediaFeature';
import { PrivateEvents } from './components/PrivateEvents';
import { VisitHours } from './components/VisitHours';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-dark selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Vendors data-id="element-4" />
        <MediaFeature data-id="element-5" />
        <PrivateEvents data-id="element-6" />
        <VisitHours data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}